import { Estabelecimento } from "@/contexts/cadastro/estabelecimento/model/Estabelecimento";
import { api } from "@/shared/api/api";

export const createEstabelecimentoApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const listAll = async () => {
    const { data } = await api.get<Estabelecimento[]>(
      "/estabelecimentos/todos",
      { headers }
    );
    return data;
  };

  return { listAll };
};
